<template>
  <div>
    <!-- //^ ^--------------新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      title="新增合伙人"
      :visible.sync="dialog.visible"
      append-to-body
      :modal-append-to-body="false"
      @closed="beforeClose"
      width="50%"
    >
      <!-- 表单 -->
      <el-form :model="params" :rules="rules" label-width="120px" ref="form">
        <el-form-item label="公司名称：" prop="companyId">
          <!-- 下拉选择 单选，非必填 枚举：公司管理里的数据-->
          <el-select
            style="margin-right: 10px"
            v-model="params.companyId"
            placeholder="所属公司"
            clearable
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="partnerPhoneNums">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 99 }"
            maxlength="999"
            show-word-limit
            v-model="params.partnerPhoneNums"
            placeholder="多个手机号,隔开"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 保存-取消 -->
      <span slot="footer" style="flex-end">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Message from '@/components/Message'
import { validatePhone } from '@/views/enterpriseDistribution/parnterManage/utils/index'
import { addPartner } from '@/api/enterpriseDistribution/parnterManage/index'
export default {
  name: 'WebSassAdd',
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          id: '',
          companyId: '',
          partnerPhoneNums: ''
        }
      }
    },
    companyList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false,
        title: this.params.id ? '编辑合伙人' : '新增合伙人'
      },
      rules: {
        companyId: [
          {
            required: false,
            message: '请输入公司名称',
            trigger: 'blur'
          }
        ],
        partnerPhoneNums: [
          {
            required: true,
            validator: validatePhone,
            message: '请输入正确手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // ^ ^--------------对话框内的事件-------------^ ^
    /** 确认的事件 */
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          console.log('验证通过', this.params)
          const params = { ...this.params }
          /** 如果有换行符号 */
          if (params.partnerPhoneNums.includes('\n')) {
            params.partnerPhoneNums = params.partnerPhoneNums
              .split('\n')
              .join(',')
          }
          const { data } = await addPartner(params)
          console.log('添加合伙人的响应', data)
          if (data.code === 200) {
            Message.success('保存成功')
            this.$emit('refresh')
          }
          this.hide()
        } else {
          /** 验证失败 */
          Message.error('请检查表单是否填写正确')
        }
      })
    },
    show(row) {
      if (row) {
        console.log('编辑', row)
        this.params = { ...row }
      }
      this.dialog.visible = true
    },
    hide() {
      this.dialog.visible = false
    },
    beforeClose() {
      console.log('beforeClose')
      /** 清理表单数据 */
      this.$refs.form.resetFields()
      this.params.id = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  padding-right: 50px !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>